<template>
  <div class="home">
    <div id="backgroundDiv" class="login-bg-image" style="background-image: none"></div>
    <div id="default-landing">
      <div data-se="landing-container-center" class="landing-container-center main-container">
        <div id="sonosHeader" class="sonos-header" style="display: none;"></div>
        <div class="landing-content validation">
          <div>
            <h2 data-se="landing-head">{{ welcome_text }}</h2>
            <p data-se="landing-head2">{{ message }}</p>
          </div>
          <div class="landing-content-inner"></div>
          <img src="/landing/img/check.png" />
          <button class="landing-button" v-if="!isMobile" @click="redirect">{{ $t("button.continue") }}</button>
        </div>
        <div id="sonosFooter" class="sonos-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getQueryParams } from "@/auth"

export default {
  name: "Validation",

  data() {
    return {
      welcome_text: "",
      message: "",
      isMobile: false,
    };
  },
  mounted() {
    this.checkIfMobile();
  },

  created: function() {
    this.params = getQueryParams();

    switch (this.params.get("type_hint")) {
      case "EMAIL_VERIFICATION":
        this.welcome_text = this.$t("email.welcome");
        this.message = this.$t("email.message") + this.params.get("login_hint");
        break;
      case "PASSWORD_RECOVERY":
        this.welcome_text = this.$t("password.welcome");
        this.message = this.$t("password.message");
        break;
    }
  },
  methods: {
      getCookieValue: function(name) {
          return document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || "";
      },
      redirect: function() {
          const continueLink = this.getCookieValue("appUrl");
          window.location.href = continueLink != "" ? continueLink : "https://www.sonos.com";
      },
      checkIfMobile: function() {
        const userAgent = navigator.userAgent;
        this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
      },
  },
};
</script>
